export default __webpack_public_path__ + "3f9e58ffbd8d988d7dd2555dda1c5301.svg";